// extracted by mini-css-extract-plugin
export default {"notes":"a09qs6BhZs57ZLbyihoWLg=="};